import { REGION_NAMES } from "../../../../../connector/connector-form/constants/constants";

// REGION_NAMES is a shared connector map that also contains non-AWS regions
// (Azure/GCP names, GovCloud) and even DB engine names. VPC peering is AWS-only,
// and the service validates aws_region against ^[a-z]{2}-[a-z]+-\d+$, so restrict
// the dropdown to valid AWS region codes — otherwise the API 400s on submit.
const AWS_REGION_CODE = /^[a-z]{2}-[a-z]+-\d+$/;

const VPC_PEERING_DOC_PATH =
  '/getting-started/connection-options/connecting-through-amazon-web-services/connecting-through-aws-vpc-peering/';

// getLinkURL only appends `path` to the docs base (section is tracking-only),
// so the anchor must be part of the path for the SBS/doc to deep-link.
export const VPC_PEERING_INITIATE_DOC_LINK = `${VPC_PEERING_DOC_PATH}#create-a-vpc-peering-connection-request`;
export const VPC_PEERING_ACCEPT_DOC_LINK = `${VPC_PEERING_DOC_PATH}#accept-the-vpc-peering-connection-request`;

export const AWS_REGIONS = Object.keys(REGION_NAMES)
  .filter((region) => AWS_REGION_CODE.test(region))
  .map((region) => ({
    label: REGION_NAMES[region],
    value: region
  }));
